import { useEffect,useState } from 'react'
import axios from 'axios'
import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Grid, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const Versions = () => {

    const [versions,setVersions] = useState([])
    const [expanded,setExpanded] = useState(false)
    
    useEffect(() => {
        axios.get('https://petromah.sabinarya.com/service/api/Info/getVersions').then(({ data }) => {
            if(data.status)
                setVersions(data.result)
        })
    },[])

    const handleChange = panel => (event,isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    }

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">ویژگی نسخه های اپلیکیشن</h3>
            <div className="safe-area">
                <Box sx={{mb: 5}}>
                    {versions.length ? versions.map((v,index) => <Accordion expanded={expanded === `versions-${index}`} onChange={handleChange(`versions-${index}`)}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography sx={{ width: '66%', flexShrink: 0,fontSize: 16 }}>نسخه {v.versionId}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <ul className="version-details">
                                {v.version_Info.split('-').map((i,index) => {
                                    if(i)
                                        return <li style={{fontSize: 14}} key={`list-${index}`}>{i}</li>
                                })}
                            </ul>
                        </AccordionDetails>
                    </Accordion>) : <Alert variant="standard" color="info">اطلاعاتی یافت نشد</Alert>}
                </Box>
            </div>
        </Grid>
    )
}

export default Versions